import { RightOutlined } from "@ant-design/icons";
import React from "react";

// Shared breadcrumb + status header for the KPI management pages.
// `items` is the breadcrumb trail: all but the last entry may have an
// `onClick` to navigate back; the last entry renders as plain (current) text.
// `status`, when given, renders as a heading directly below the breadcrumb trail.
// `actions`, when given, renders alongside the status heading, right-aligned.
const BreadcrumbStatus = ({ items, status, actions }) => (
  
  <div className="breadcrumb mb-3">
    {console.log("status-->",status)}
    <div className="d-flex align-items-center">
      {items.map((item, idx) => (
        <React.Fragment key={idx}>
          {idx > 0 && (
            <>
              &nbsp;
              <RightOutlined className="mt-1" />
              &nbsp;
            </>
          )}
          <p
            className={item.onClick ? "lite-text p-0 m-0" : "m-0 p-0"}
            style={item.onClick ? { cursor: "pointer" } : undefined}
            onClick={item.onClick}
          >
            {item.label}
          </p>
        </React.Fragment>
      ))}
    </div>
    {status && (
      <div className="mt-3 d-flex align-items-center justify-content-between">
        <h6 className="m-0" style={{ fontSize: 18, fontWeight: 600 }}>
          {status === "Yet to Accept" ? "" : status === "Accepted" ? "Performance KPI - Accepted" : status}
        </h6>
        {actions}
      </div>
    )}
  </div>
);

export default BreadcrumbStatus;
